export default __webpack_public_path__ + "static/media/birubi-landscape.887c7ff9.jpeg";